import {
  object as yupObject,
  string as yupString,
  bool as yupBool,
  mixed,
  number as yupNumber,
} from 'yup';
import { ADD_EMPLOYEE_FORM_TRANSLATIONS } from 'const/translations';

const {
  GENERAL_LABELS,
  WORK_CONTRACT_FORM_TAB: { LABELS },
} = ADD_EMPLOYEE_FORM_TRANSLATIONS;

export const validationSchema = () =>
  yupObject().shape({
    contractByExco: yupBool(),
    dpaeByExco: yupBool(),
    employeePosition: yupString().required('Field cannot be empty'),
    datetimeHire: mixed().required('Field cannot be empty'),
    classification: yupString().required('Field cannot be empty'),
    levelCoefficient: yupString(),
    remunerationGross: yupString().required('Field cannot be empty'),
    salaryGross: yupNumber().required('Field cannot be empty'),

    // Упрощаем условия - убираем when и используем test
    remunerationGrossDetails: yupString()
      .nullable()
      .test(
        'remunerationGrossDetails-required',
        'Field cannot be empty',
        function (value) {
          const { remunerationGross } = this.parent;
          if (remunerationGross === GENERAL_LABELS.OTHER) {
            return !!value;
          }
          return true;
        }
      ),

    typeEmployment: yupString().required('Field cannot be empty'),

    employmentParttimeDetails: yupString()
      .nullable()
      .test(
        'employmentParttimeDetails-required',
        'Field cannot be empty',
        function (value) {
          const { typeEmployment } = this.parent;
          if (typeEmployment === GENERAL_LABELS.PARTTIME) {
            return !!value;
          }
          return true;
        }
      ),

    typeContract: yupString().required('Field cannot be empty'),

    typeContractDetails: yupString()
      .nullable()
      .test(
        'typeContractDetails-required',
        'Field cannot be empty',
        function (value) {
          const { typeContract } = this.parent;
          if (typeContract === GENERAL_LABELS.OTHER) {
            return !!value;
          }
          return true;
        }
      ),

    typeCDD: yupString()
      .nullable()
      .test('typeCDD-required', 'Field cannot be empty', function (value) {
        const { typeContract } = this.parent;
        if (typeContract === LABELS.CONTRACT_TYPE_CDD) {
          return !!value;
        }
        return true;
      }),

    termCDD: mixed()
      .nullable()
      .test('termCDD-required', 'Field cannot be empty', function (value) {
        const { typeContract, typeCDD } = this.parent;
        if (typeContract === LABELS.CONTRACT_TYPE_CDD && typeCDD) {
          return value !== null && value !== undefined && value !== '';
        }
        return true;
      }),

    workerReplaced: yupString()
      .nullable()
      .test(
        'workerReplaced-required',
        'Field cannot be empty',
        function (value) {
          const { typeContract, typeCDD } = this.parent;
          if (
            typeContract === LABELS.CONTRACT_TYPE_CDD &&
            typeCDD === LABELS.WORKER_REPLACE
          ) {
            return !!value;
          }
          return true;
        }
      ),
  });
